import { db, auth } from './firebase'
import {
    collection,
    addDoc,
    doc,
    updateDoc,
    deleteDoc,
    serverTimestamp
} from 'firebase/firestore'

/**
 * Submit a new identification request
 * @param {Object} data - Submission data including images, category, etc.
 */
export async function submitIdentification(data) {
    const user = auth.currentUser
    if (!user) throw new Error('User must be authenticated')

    const docRef = await addDoc(collection(db, 'identifications'), {
        ...data,
        userId: user.uid,
        status: 'pending',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
    })

    return docRef.id
}

/**
 * Approve an identification result - saves to history
 * @param {string} id - Identification document ID
 * @param {Object} finalChoice - (Optional) The specific hallmark match chosen by the user
 */
export async function approveIdentification(id, finalChoice = null) {
    const user = auth.currentUser
    if (!user) throw new Error('User must be authenticated')

    const updateData = {
        status: 'approved',
        approvedAt: serverTimestamp(),
        userFeedback: 'correct',
        updatedAt: serverTimestamp()
    }

    // If the user made a manual selection, override the primary result fields
    if (finalChoice) {
        updateData.manufacturer = finalChoice.manufacturer;
        updateData.identifiedManufacturer = finalChoice.manufacturer; // Ensure legacy/frontend compatibility
        updateData.matchedHallmarkImage = finalChoice.imageUrl;
        updateData.selectedMatchId = finalChoice.id;

        // Also update the inferred list for display consistency in history
        updateData.inferred = {
            possibleManufacturers: [finalChoice.manufacturer]
        };
    }

    await updateDoc(doc(db, 'identifications', id), updateData)
}

/**
 * Reject an identification result - removes from system
 * @param {string} id - Identification document ID
 */
export async function rejectIdentification(id) {
    const user = auth.currentUser
    if (!user) throw new Error('User must be authenticated')

    // Option 1: Mark as rejected (keeps data for improvement)
    await updateDoc(doc(db, 'identifications', id), {
        status: 'rejected',
        rejectedAt: serverTimestamp(),
        userFeedback: 'incorrect',
        updatedAt: serverTimestamp()
    })

    // Option 2: Delete entirely (uncomment if preferred)
    // await deleteDoc(doc(db, 'identifications', id))
}

